import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';  
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Response } from '../../../shared/interfaces/response/response';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class AuditarService {

  private _url = environment.apiBaseUrl + 'api/Auditar/';

  constructor(private _http: HttpClient) {}

  read(id: any): Observable<Response> {
    const url = `${this._url}${id}`;
    return this._http.get<Response>(url);
  } 
}
